import React, { useEffect, useState } from 'react';
import MedicalReportDetailMouForm from './MedicalReportDetailMouForm';
import { FormValues } from '../../Modules/MagicForm/Interfaces/FormValues';
import { DekurzFormValues } from '../Dekurz/Dekurz';
import usePatientConsent from '../PatientProfile/Hooks/usePatientConsent';

interface MedicalReportDetailMouProps {
	patientId: string;
	workplaceId: string;
	loggedUserId: string;
	onSuccess?: (values: FormValues) => void;
	defaultData?: any;
	customSuccess?: (values: FormValues) => void;
}

interface MedicalReportMouDefaults extends DekurzFormValues {
	title: string;
	sendToPatient?: boolean;
}

const MedicalReportDetailMou: React.FC<MedicalReportDetailMouProps> = ({
	defaultData,
	onSuccess,
	customSuccess,
	workplaceId,
	patientId,
}) => {
	const { isConsentProvided } = usePatientConsent(patientId);
	const [initialized, setInitialized] = useState(true);

	const [defaultValues, setDefaultValues] = useState<MedicalReportMouDefaults>({
		diagnoses: [{ value: undefined, label: undefined }],
		...defaultData,
	});

	useEffect(() => {
		setDefaultValues({ ...defaultValues, sendToPatient: isConsentProvided });
	}, [isConsentProvided]);

	if (!initialized) {
		return null;
	}

	return (
		<MedicalReportDetailMouForm
			onSubmit={customSuccess ? customSuccess : onSuccess}
			defaultData={defaultValues}
			workplaceId={workplaceId}
			patientId={patientId}
		/>
	);
};

export default MedicalReportDetailMou;
